import { render, staticRenderFns } from "./EmailHistory.vue?vue&type=template&id=66fecf95&scoped=true&"
import script from "./EmailHistory.vue?vue&type=script&lang=ts&"
export * from "./EmailHistory.vue?vue&type=script&lang=ts&"
import style0 from "./EmailHistory.vue?vue&type=style&index=0&id=66fecf95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fecf95",
  null
  
)

export default component.exports